var map = {
	"./Screenshot 2025-05-11 141812.png": 414,
	"./Screenshot 2025-05-11 141815.png": 842,
	"./Screenshot 2025-05-11 141818.png": 775,
	"./Screenshot 2025-05-11 141821.png": 35,
	"./Screenshot 2025-05-11 141824.png": 548,
	"./Screenshot 2025-05-11 141828.png": 167,
	"./Screenshot 2025-05-11 141831.png": 400,
	"./Screenshot 2025-05-11 141832.png": 360,
	"./Screenshot 2025-05-11 141834.png": 822,
	"./Screenshot 2025-05-11 141843.png": 399
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 489;